import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SuitPressIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SuitPressIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.0901 8.92134C11.8206 8.92134 11.6012 9.14039 11.6012 9.40991V10.0588C11.6012 10.3283 11.8206 10.5474 12.0901 10.5474C12.3596 10.5474 12.5786 10.3283 12.5786 10.0588V9.40991C12.5786 9.14039 12.3596 8.92134 12.0901 8.92134Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0901 12.4045C11.8206 12.4045 11.6012 12.6235 11.6012 12.893V13.5419C11.6012 13.8115 11.8206 14.0309 12.0901 14.0309C12.3596 14.0309 12.5786 13.8115 12.5786 13.5419V12.893C12.5786 12.6235 12.3596 12.4045 12.0901 12.4045Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.7051 4.34262H16.8734L16.0305 2.6953C15.9574 2.52981 15.7957 2.42407 15.6161 2.42407L8.56952 2.42441C8.38996 2.42441 8.22516 2.5305 8.1479 2.69839L7.30673 4.34296H5.47469C4.20229 4.34296 3.16748 5.37777 3.16748 6.64983V21.4476C3.16748 21.7167 3.38687 21.9358 3.65639 21.9358H20.5238C20.7933 21.9358 21.0123 21.7167 21.0123 21.4476V6.64983C21.0123 5.37743 19.9775 4.34262 18.7051 4.34262ZM16.8271 5.32009H17.6432L17.6878 10.7795L16.6084 11.485C16.4192 11.6086 16.3395 11.8441 16.4147 12.0577L17.1721 14.1929L12.9869 19.288L15.5798 7.12671L16.8271 5.32009ZM16.0044 4.79101L14.0052 7.68635L12.8015 6.7257L15.4798 3.76615L16.0044 4.79101ZM14.491 3.40188L12.0901 6.05449L9.68914 3.40188H14.491ZM8.69999 3.76616L11.3784 6.72571L10.1746 7.68636L8.17572 4.79102L8.69999 3.76616ZM6.53217 5.32009H7.35274L8.60042 7.12672L11.1524 19.0964L7.42725 14.1627L7.78672 11.9732C7.81796 11.7823 7.7335 11.5908 7.57179 11.485L6.492 10.7795L6.53217 5.32009ZM4.14496 20.9587V6.64983C4.14496 5.91681 4.74168 5.32009 5.4747 5.32009H5.55435L5.51212 11.0387C5.51075 11.2059 5.59383 11.3604 5.73357 11.4517L6.7701 12.1291L6.42848 14.2108C6.40685 14.3419 6.44015 14.4779 6.52049 14.5843L11.3327 20.9587L4.14496 20.9587ZM9.97273 8.87395C9.98131 8.87567 9.9899 8.87738 9.99848 8.87841C10.1317 8.89901 10.2697 8.8609 10.3751 8.77713L12.0901 7.4086L13.8047 8.77713C13.9098 8.8609 14.0512 8.8997 14.1806 8.87841C14.1896 8.87738 14.1985 8.87566 14.2071 8.87395L12.0897 18.8053L9.97273 8.87395ZM20.0349 20.9587H12.8798L18.1033 14.5994C18.2114 14.4683 18.2433 14.2863 18.1863 14.1263L17.465 12.0934L18.4466 11.4517C18.5867 11.36 18.6694 11.2055 18.6677 11.0383L18.621 5.32008H18.7051C19.4381 5.32008 20.0349 5.9168 20.0349 6.64982L20.0349 20.9587Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SuitPressIcon;
